$('#heroBanner.owl-carousel').owlCarousel({
    loop: true,
    dots: true,
    nav: false,
    items: 1,
    autoplay: false,
    slideTransition: 'linear',
    autoplaySpeed: 2000,
    autoplayTimeout: 6000,
    margin: 0,
    responsiveClass: true,
    responsive: {
        0: {
            items: 1,
        },
        600: {
            items: 1,
        },
        1000: {
            items: 1,
        }
    },
    animateOut: 'slideOutLeft', // Animation when sliding out
    animateIn: 'slideInRight'   // Animation when sliding in
})

$('#republic-banner.owl-carousel').owlCarousel({
    loop: true,
    dots: true,
    nav: false,
    autoplay: true,
    slideTransition: 'linear',
    autoplaySpeed: 2000,
    autoplayTimeout: 6000,
    margin: 0,
    responsiveClass: true,
    responsive: {
        0: {
            items: 1,
        },
        600: {
            items: 1,
        },
        1000: {
            items: 1,
        }
    },
    animateOut: 'slideOutLeft', // Animation when sliding out
    animateIn: 'slideInRight'   // Animation when sliding in
})